import { render, staticRenderFns } from "./JavascriptComponentsSection.vue?vue&type=template&id=d54cec0a&"
import script from "./JavascriptComponentsSection.vue?vue&type=script&lang=js&"
export * from "./JavascriptComponentsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports